import React, { useState, useRef } from "react";
import PropTypes from "prop-types";

const propTypes = {
  label: PropTypes.string.isRequired,
  totalCount: PropTypes.number.isRequired,
  zips: PropTypes.arrayOf(
    PropTypes.shape({
      postal_code: PropTypes.string,
      count: PropTypes.number,
      category: PropTypes.string
    })
  ).isRequired
};

const SpotsInfo = ({ label, totalCount, zips }) => {
  const [isOpen, setIsOpen] = useState(false);
  const closeTimer = useRef(null);

  const openPopover = () => {
    clearTimeout(closeTimer.current);
    setIsOpen(true);
  };

  const closePopover = () => {
    closeTimer.current = setTimeout(() => setIsOpen(false), 120);
  };

  const togglePopover = () => setIsOpen(prev => !prev);

  return (
    <div onMouseEnter={openPopover} onMouseLeave={closePopover}>
      <button
        type="button"
        className="spots-info__trigger"
        onClick={togglePopover}
        aria-expanded={isOpen}
      >
        <span className="font-weight-bold">
          {totalCount} {label} Spots
        </span>
        <i className="fa fa-circle-info ml-1" />
      </button>
      {isOpen && (
        <div className="spots-info__popover" onMouseEnter={openPopover} onMouseLeave={closePopover}>
          <ul className="mb-0 pl-3">
            {zips.map(zip => (
              <li key={zip.postal_code + zip.category}>
                {zip.count} &times; {zip.postal_code}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

SpotsInfo.propTypes = propTypes;

export default SpotsInfo;
